import { useTranslation } from "react-i18next";
import React, { useState, useEffect } from 'react';
import { useLocation } from 'react-router-dom';
const FloatingHelp = () => {
  const {
    t
  } = useTranslation();
  const location = useLocation();
  const [isHelpOpen, setIsHelpOpen] = useState(false);
  useEffect(() => {
    // Open by default only on the exact start of the quote (Form 1) or claim registration
    const isQuoteStart = location.pathname === '/products/replacement-insurance/quote' && !location.search;
    const isClaimRegisterStart = location.pathname === '/claims/replacement-insurance/register';
    if (isQuoteStart || isClaimRegisterStart) {
      setIsHelpOpen(true);
    } else {
      setIsHelpOpen(false);
    }
  }, [location.pathname, location.search]);

  useEffect(() => {
    const handleOpenHelp = () => {
      setIsHelpOpen(true);
    };
    window.addEventListener('open-floating-help', handleOpenHelp);
    window.addEventListener('open-broker-chat', handleOpenHelp);
    return () => {
      window.removeEventListener('open-floating-help', handleOpenHelp);
      window.removeEventListener('open-broker-chat', handleOpenHelp);
    };
  }, []);
  return <div className="fixed bottom-6 right-6 z-50 flex items-end justify-end">
      {/* Tooltip Content */}
      <div className={`absolute right-16 bottom-0 mr-4 transition-all duration-300 ease-out flex flex-col items-end origin-bottom-right ${isHelpOpen ? 'opacity-100 translate-x-0 pointer-events-auto scale-100' : 'opacity-0 translate-x-4 pointer-events-none scale-95'}`}>
        <div className="bg-white/95 backdrop-blur-xl rounded-3xl shadow-[0_20px_50px_rgba(0,0,0,0.15)] border border-white/60 p-6 mb-2 min-w-[300px] relative overflow-hidden">
          <div className="absolute -top-10 -right-10 w-28 h-28 bg-primary/10 rounded-full blur-2xl pointer-events-none"></div>
          <button onClick={() => setIsHelpOpen(false)} className="absolute top-4 right-4 text-slate-400 hover:text-slate-700 bg-white hover:bg-slate-50 rounded-full w-8 h-8 flex items-center justify-center transition-colors shadow-sm border border-slate-100" aria-label={t("floatinghelp_attr_563")}>
            <span className="material-symbols-outlined text-[16px]">close</span>
          </button>
          <div className="flex items-center gap-3 mb-4 pr-8">
            <span className="text-3xl origin-bottom-right animate-[wave_2.5s_ease-in-out_infinite]">👋</span>
            <h4 className="font-headline font-extrabold text-[17px] text-slate-900 leading-tight">
              <span dangerouslySetInnerHTML={{
              __html: t("floatinghelp_span_564")
            }} />
              
            </h4>
          </div>
          <p className="font-body text-[13px] text-slate-500 mb-6 leading-relaxed pr-2">
            <span dangerouslySetInnerHTML={{
            __html: t("floatinghelp_span_565")
          }} />
            
          </p>
          <div className="flex flex-col gap-2.5">
            <a href="tel:+15143645715" className="group flex items-center justify-center gap-2 w-full py-3 px-4 bg-primary text-white font-bold text-sm rounded-2xl hover:bg-primary-fixed-variant transition-all hover:shadow-[0_8px_20px_rgba(0,82,255,0.3)]">
              <span className="material-symbols-outlined text-[18px] group-hover:scale-110 transition-transform">phone_in_talk</span>
              +1 514 364 5715
            </a>
            <div className="flex items-center justify-between gap-2 w-full py-2.5 px-4 bg-slate-100/80 border border-slate-200/60 text-slate-700 font-bold text-xs rounded-2xl">
              <div className="flex items-center gap-2">
                <span className="material-symbols-outlined text-[16px] text-primary">chat</span>
                <span>{t("floatinghelp_span_564")?.toLowerCase().includes("besoin") || document.documentElement.lang === "fr" ? "Clavardage instantané" : "Instant Chat"}</span>
              </div>
              <span className="px-2 py-0.5 rounded-full text-[9px] font-extrabold uppercase tracking-wider bg-primary/10 text-primary">
                {t("floatinghelp_span_564")?.toLowerCase().includes("besoin") || document.documentElement.lang === "fr" ? "Bientôt" : "Coming Soon"}
              </span>
            </div>
            <a href="mailto:support@ello.ca" className="group flex items-center justify-center gap-2 w-full py-2.5 px-4 bg-white border border-slate-200 text-slate-600 hover:text-primary hover:border-primary/30 font-bold text-[13px] rounded-2xl transition-all hover:bg-primary/5">
              <span className="material-symbols-outlined text-[16px] group-hover:scale-110 transition-transform">mail</span>
              support@ello.ca
            </a>
          </div>
        </div>
      </div>

      {/* The Vibrating Icon Button */}
      <button onClick={() => setIsHelpOpen(!isHelpOpen)} className={`w-14 h-14 bg-primary hover:bg-primary-fixed-variant text-white rounded-full flex items-center justify-center shadow-[0_10px_25px_rgba(0,82,255,0.4)] transition-all duration-300 hover:scale-110 relative ${!isHelpOpen ? 'animate-bottle-shake' : ''}`} aria-label={t("floatinghelp_attr_566")}>
        <div className="absolute inset-0 rounded-full border border-white/20"></div>
        <span className="material-symbols-outlined text-2xl drop-shadow-md">{isHelpOpen ? 'close' : 'support_agent'}</span>
      </button>
    </div>;
};
export default FloatingHelp;